import { render, staticRenderFns } from "./realname.vue?vue&type=template&id=cf1942c6&scoped=true"
import script from "./realname.vue?vue&type=script&lang=js"
export * from "./realname.vue?vue&type=script&lang=js"
import style0 from "./realname.vue?vue&type=style&index=0&id=cf1942c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1942c6",
  null
  
)

export default component.exports